<template>
    <div :style="[elementStyles, basicContentStyles]" ref="container"
         :data-x="data.position ? data.position.left : 0"
         :data-y="data.position ? data.position.top : 0">
    </div>
</template>

<script>
    export default {
        props: ['data', 'frame', 'basicContentStyles', 'width', 'height'],
        data: function () {
            return {
                locked_ratio: false,
                stretch: 'original',
                background_image_original_height: "auto",
                background_image_original_width: "auto",
            }
        },
        computed: {
            elementStyles: function () {
                let opacity = 1;
                if (!isNaN(this.data.transparency)) {
                    opacity -= this.data.transparency/100;
                }
                // 0.999: such that border when selected is visualized correctly.
                opacity = Math.min(opacity, 0.999);

                let size = '100% 100%';

                if (this.data.stretch === 'original') {
                    var background_image_original_size = '';
                    background_image_original_size += (this.background_image_original_width === 'auto' ? 'auto' : this.background_image_original_width + "px");
                    background_image_original_size += ' ' + (this.background_image_original_height === 'auto' ? 'auto' : this.background_image_original_height + "px");
                    size = background_image_original_size;
                } else if (this.data.stretch === 'frame') {
                    size = '100% 100%';
                } else if (this.data.stretch === 'aspect_fit') {
                    size = 'contain';
                } else if (this.data.stretch === 'aspect_fill') {
                    size = 'cover';
                }
                let position = this.data.alignment;

                return {
                    backgroundImage: 'url("' + this.data.background_image + '")',
                    backgroundPosition: position,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: size,
                    opacity: opacity,
                };
            }
        },
        watch: {
            data: {
                handler: function (val, oldVal) {
                    if (this.stretch !== val.stretch) {
                        this.stretch = val.stretch;
                        this.changeStretch();
                    }
                    if (this.locked_ratio !== val.locked_ratio) {
                        this.changeLockedRatio();
                    }
                },
                deep: true
            }
        },
        methods: {
            changeStretch: function () {
                if (this.stretch === 'original') {
                    /*var newWidth = Math.min(this.background_image_original_width, this.frame.width);
                    var newHeight = Math.min(this.background_image_original_height, this.frame.height);
                    var newLeft = Math.min(this.$refs.container.getAttribute('data-x'),
                        this.frame.width - newWidth);
                    var newTop = Math.min(this.$refs.container.getAttribute('data-y'),
                        this.frame.height - newHeight);

                    this.$refs.container.style.width = newWidth + "px";
                    this.$refs.container.style.height = newHeight + "px";
                    this.$refs.container.style.webkitTransform = this.$refs.container.style.transform =
                        'translate(' + newLeft + 'px, ' + newTop + 'px)';
                    this.$refs.container.setAttribute('data-x', newLeft);
                    this.$refs.container.setAttribute('data-y', newTop);*/
                }
            },
            computeLockedRatio: function () {
                let locked_ratio = (this.data.locked_ratio === undefined ? false : this.data.locked_ratio);
                if (this.data.stretch === "aspect_fit" || this.data.stretch === "aspect_fill") {
                    locked_ratio = false;
                }
                this.locked_ratio = locked_ratio;
            },
            changeLockedRatio: function () {
                this.computeLockedRatio();
                if (this.locked_ratio === true) {
                    var newWidth = parseFloat(this.$refs.container.offsetWidth);
                    var newHeight = parseFloat(this.$refs.container.offsetHeight);
                    var newLeft = parseFloat(this.$refs.container.getAttribute('data-x'));
                    var newTop = parseFloat(this.$refs.container.getAttribute('data-y'));

                    if (newWidth < newHeight / this.data.size.ratio) {
                        newHeight = newWidth * this.data.size.ratio;
                    } else {
                        newWidth = newHeight / this.data.size.ratio;
                    }
                    if (newHeight * this.frame.ratio < this.hasMinHeight() || newWidth * this.frame.ratio < this.hasMinWidth()) {
                        newHeight = this.hasMinHeight() / this.frame.ratio;
                        newWidth = this.hasMinWidth() / this.frame.ratio;

                        if (this.data.size.ratio < 1) {
                            newWidth = newHeight / this.data.size.ratio;
                        } else {
                            newHeight = newWidth * this.data.size.ratio;
                        }
                    }
                    if (newLeft + newWidth > this.frame.width) {
                        newLeft = Math.max(0, this.frame.width - newWidth);
                    }
                    if (newTop + newTop > this.frame.height) {
                        newTop = Math.max(0, this.frame.height - newHeight);
                    }

                    this.$refs.container.style.width = newWidth + "px";
                    this.$refs.container.style.height = newHeight + "px";
                    this.$refs.container.style.webkitTransform = this.$refs.container.style.transform =
                        'translate(' + newLeft + 'px, ' + newTop + 'px)';
                    this.$refs.container.setAttribute('data-x', newLeft);
                    this.$refs.container.setAttribute('data-y', newTop);
                }
            }
        },
        mounted() {
            var backgroundImage = new Image;
            backgroundImage.addEventListener('load', () => {
                this.background_image_original_height = backgroundImage.height * this.frame.ratio;
                this.background_image_original_width = backgroundImage.width * this.frame.ratio;
            });
            backgroundImage.src = this.data.background_image;
        }
    }
</script>
